import React from 'react';
import { Link } from 'react-router-dom';
import { Logo } from './MarketingNav';

const MarketingFooter = () => (
  <footer className="bg-slate-950 border-t border-white/5">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
      <div className="flex flex-col gap-8 md:flex-row md:items-start md:justify-between">
        <div className="max-w-xs">
          <Logo size="h-7 w-7" text="text-lg" />
          <p className="mt-3 text-sm text-gray-400">ATPL theory and DLR airline screening preparation.</p>
        </div>
        <div className="grid grid-cols-2 gap-x-12 gap-y-2 text-sm">
          <Link to="/pricing" className="text-gray-400 hover:text-white">Pricing</Link>
          <Link to="/login" className="text-gray-400 hover:text-white">Log in</Link>
          <Link to="/register" className="text-gray-400 hover:text-white">Create account</Link>
          <Link to="/privacy" className="text-gray-400 hover:text-white">Privacy Policy</Link>
          <Link to="/terms" className="text-gray-400 hover:text-white">Terms of Service</Link>
          <Link to="/refund-policy" className="text-gray-400 hover:text-white">Refund Policy</Link>
        </div>
      </div>
      <p className="mt-10 text-xs text-gray-500">© {new Date().getFullYear()} AirBrief. All rights reserved.</p>
    </div>
  </footer>
);

export default MarketingFooter;
